import styled from 'styled-components';

import { basic } from '../../theme/colors';

/** Inline validation error text displayed next to a form label. */
export const ValidationError = styled.span.attrs({ 'aria-live': 'polite' })`
  color: ${basic.haydenRed};
  margin-left: 8px;
  font-weight: normal;
  font-size: 0.85rem;
`;
